interface ScaData {
  nonWorkingDays?: number
  normalWeekWorkingDays?: number
  absenceReasonText?: string
}

interface Props {
  sca: ScaData
}

function WorkingDaysSection({ sca }: Props) {
  return (
    <>
      <h3>Of which were during non-working days off</h3>
      <p>{sca.nonWorkingDays}</p>
      <br />
      <h3>Usual number of days worked per week</h3>
      <p>{sca.normalWeekWorkingDays}</p>
      <br />
      <div className="line">
        <div className="item bold" style={{ flexGrow: 7 }}>
          Reason for absence
        </div>
        <div className="item" style={{ flexGrow: 2 }}>
          &nbsp;
        </div>
        <div className="item" style={{ flexGrow: 1 }} />
      </div>
      <div className="input long">{sca.absenceReasonText}</div>
      <br />
      <br />
      <br />
    </>
  )
}

export default WorkingDaysSection